import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HtmlElementBoardComponent } from './html-element-board/html-element-board.component';

@NgModule({
    exports: [HtmlElementBoardComponent],
    imports: [CommonModule, HtmlElementBoardComponent],
})
export class TeacherPreviewHtmlElementsModule {}
